@for (field of headerFields(); track field) {
  <div class="record-address-content">
    <p>
      @if (templateProjectionMap() != null && field.options.hasAnchor) {
        <ng-container
          [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-goes-to-record'"
      [ngTemplateOutletContext]="{
        classes: 'record-link',
        urlParams: reportRecordData() | reportFieldRouteFn: { templateId: currentView().templateId, field: field },
        content: addressField,
      }"
          >
        </ng-container>
      } @else {
        <span>
          {{
          reportRecordData()
          | reportFieldFormatter
          : { templateId: currentView()?.templateId, field: field, joinString: true, onlyUrl: false }
          | async
          }}
        </span>
      }
    </p>
  </div>
}
